import { useEffect, useState } from "react";
import { Check, Loader2, X } from "lucide-react";

export default function CmsEditableText({
  as: Tag = "span",
  className = "",
  editMode = false,
  fieldKey,
  multiline = false,
  onSave,
  sectionKey,
  value = "",
}) {
  const [draft, setDraft] = useState(value || "");
  const [saving, setSaving] = useState(false);
  const dirty = draft !== (value || "");

  useEffect(() => {
    setDraft(value || "");
  }, [value]);

  const save = async () => {
    if (!dirty || saving) return;
    setSaving(true);
    try {
      await onSave?.(sectionKey, fieldKey, draft);
    } finally {
      setSaving(false);
    }
  };

  if (!editMode) {
    return <Tag className={className}>{String(value || "").split("\n").map((line, index, lines) => (
      <span key={`${line}-${index}`}>
        {line}
        {index < lines.length - 1 && <br />}
      </span>
    ))}</Tag>;
  }

  const Input = multiline ? "textarea" : "input";

  return (
    <span className="group/cms relative block rounded-xl border border-dashed border-[#4391d1]/50 bg-white/80 p-2 shadow-sm ring-4 ring-blue-50/60" onClick={(event) => event.preventDefault()}>
      <span className="mb-1 block text-[10px] font-black uppercase tracking-widest text-[#1278b5]">
        Editable: {sectionKey}.{fieldKey}
      </span>
      <Input
        className={`w-full resize-y rounded-lg border border-gray-200 bg-white px-3 py-2 text-slate-900 outline-none focus:border-[#4391d1] focus:ring-2 focus:ring-blue-100 ${className} text-[#000]`}
        onChange={(event) => setDraft(event.target.value)}
        rows={multiline ? Math.max(3, String(draft || "").split("\n").length) : undefined}
        value={draft}
      />
      {dirty && (
        <span className="mt-2 flex items-center gap-2">
          <button
            className="inline-flex h-8 items-center gap-1 rounded-lg bg-[#4391d1] px-3 text-xs font-black uppercase text-white hover:bg-blue-600"
            disabled={saving}
            onClick={save}
            type="button"
          >
            {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />}
            Save
          </button>
          <button
            className="inline-flex h-8 items-center gap-1 rounded-lg border border-gray-200 bg-white px-3 text-xs font-black uppercase text-gray-600 hover:border-gray-300"
            disabled={saving}
            onClick={() => setDraft(value || "")}
            type="button"
          >
            <X className="h-3.5 w-3.5" />
            Cancel
          </button>
        </span>
      )}
    </span>
  );
}
